import fileDownload from "js-file-download";
import getDates from "./date.service";

const downloadFile = (response, report, car, format = { title: "xlsx" }, options) => {
  const { startDate, endDate } = options;
  let localStartDate = getDates.getDateFormat8(getDates.getLocalDate(startDate));
  let localEndDate = getDates.getDateFormat8(getDates.getLocalDate(endDate));
  let filename = "";

  if (car !== null && car !== undefined) {
    filename = `${report.title} ${car.registerNumber} c ${localStartDate} по ${localEndDate}.${format.title}`;
  } else {
    filename = `${report.title} c ${localStartDate} по ${localEndDate}.${format.title}`;
  }

  fileDownload(response, filename);
};

export { downloadFile };
